import {styled, Typography} from '@mui/material';

export const HelperText = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.pxToRem(15),
  color: '#4D5562',
}));
